<template>
  <div class="performance-dashboard-skeleton">
    <!-- Top Metrics Cards Skeleton -->
    <b-row class="match-height mb-2">
      <b-col
        v-for="i in 4"
        :key="i"
        lg="3"
        sm="6"
        class="mb-1"
      >
        <b-card>
          <div class="d-flex justify-content-between align-items-start">
            <div class="flex-grow-1">
              <b-skeleton
                width="60%"
                height="2rem"
                class="mb-1"
              />
              <b-skeleton
                width="80%"
                height="1rem"
              />
            </div>
            <b-skeleton
              type="avatar"
              size="45px"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Middle Section: Charts and Indicators Skeleton -->
    <b-row class="match-height mb-2">
      <!-- Completion Rate Chart Skeleton -->
      <b-col
        lg="4"
        md="6"
        class="mb-1"
      >
        <b-card>
          <b-skeleton
            width="40%"
            height="1.5rem"
            class="mb-2"
          />
          <b-skeleton-img
            no-aspect
            height="280px"
            class="mb-2"
          />
          <b-skeleton
            width="30%"
            height="2rem"
            class="mx-auto mt-1"
          />
          <b-skeleton
            width="20%"
            height="1rem"
            class="mx-auto"
          />
        </b-card>
      </b-col>

      <!-- Tasks by Status Chart Skeleton -->
      <b-col
        lg="4"
        md="6"
        class="mb-1"
      >
        <b-card>
          <b-skeleton
            width="40%"
            height="1.5rem"
            class="mb-2"
          />
          <b-skeleton-img
            no-aspect
            height="280px"
            class="mb-2"
          />
          <div
            v-for="i in 3"
            :key="i"
            class="d-flex justify-content-between align-items-center mt-1"
          >
            <b-skeleton width="40%" />
            <b-skeleton width="15%" />
            <b-skeleton width="15%" />
          </div>
        </b-card>
      </b-col>

      <!-- Performance Indicators Skeleton -->
      <b-col
        lg="4"
        md="12"
        class="mb-1"
      >
        <b-card>
          <b-skeleton
            width="50%"
            height="1.5rem"
            class="mb-2"
          />

          <!-- Progress Bar Skeletons -->
          <div
            v-for="i in 3"
            :key="i"
            class="mb-2"
          >
            <div class="d-flex justify-content-between mb-1">
              <b-skeleton width="45%" />
              <b-skeleton width="20%" />
            </div>
            <b-skeleton
              height="8px"
              class="mb-1"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Bottom Section: Trend Charts Skeleton -->
    <b-row class="match-height">
      <!-- Monthly Task Trend Skeleton -->
      <b-col
        lg="6"
        md="12"
        class="mb-1"
      >
        <b-card>
          <b-skeleton
            width="40%"
            height="1.5rem"
            class="mb-2"
          />
          <b-skeleton-img
            no-aspect
            height="300px"
          />
        </b-card>
      </b-col>

      <!-- Weekly Activity Skeleton -->
      <b-col
        lg="6"
        md="12"
        class="mb-1"
      >
        <b-card>
          <b-skeleton
            width="40%"
            height="1.5rem"
            class="mb-2"
          />
          <b-skeleton-img
            no-aspect
            height="300px"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BSkeleton,
  BSkeletonImg,
  BCard,
  BRow,
  BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BSkeleton,
    BSkeletonImg,
    BCard,
    BRow,
    BCol,
  },
}
</script>

<style lang="scss" scoped>
.performance-dashboard-skeleton {
  .gap-1 {
    gap: 0.25rem;
  }
}
</style>
